export default __webpack_public_path__ + "assets/apple-icon-57x57.aeb92cd6b7af5faeca9bc3461d67fc21.png";